<template>
    <div>
        <v-row>
            <v-col cols="12" md="6" class="my-2 px-1">
                <v-date-picker
                    :landscape="$vuetify.breakpoint.smAndUp"
                    ref="picker"
                    :allowed-dates="allowedDates"
                    :events="arrayEvents"
                    v-model="datenew"
                    :picker-date.sync="pickerDate"
                    full-width
                ></v-date-picker>
            </v-col>
            <v-col cols="12" sm="6" class="my-2 px-1" v-if="zoneselect != ''">
                <v-row>
                    <v-col cols="11" sm="5">
                        <v-select
                            label="ZONE"
                            :items="zone"
                            item-text="branch_name"
                            item-value="branch_id"
                            v-model="zoneselect"
                            dense
                            outlined
                            @change="getDetail()"
                        ></v-select>
                    </v-col>
                    <v-col cols="11" sm="5" v-if="zoneselect != ''">
                        <v-select
                            v-if="showengineer"
                            :items="engineer"
                            item-text="emp_name_en"
                            item-value="emp_id"
                            v-model="engineerselect"
                            label="Engineer"
                            dense
                            outlined
                            clearable
                            @change="chooseEngineer()"
                        ></v-select>
                    </v-col>
                    <v-col cols="1" v-if="zoneselect != '' && datenew != ''">
                        <v-tooltip left>
                            <template v-slot:activator="{ on, attrs }">
                                <v-btn
                                    fab
                                    small
                                    :color="
                                        chk_export_data == false
                                            ? 'green accent-3'
                                            : ''
                                    "
                                    :disabled="chk_export_data == true"
                                    class="mr-1"
                                    @click="export_data()"
                                    v-bind="attrs"
                                    v-on="on"
                                >
                                    <v-icon
                                        v-if="chk_export_data == false"
                                        color="teal darken-4"
                                        >mdi-file-excel</v-icon
                                    >
                                    <img
                                        v-if="chk_export_data == true"
                                        src="../../../assets/all/Loading.gif"
                                        style="width: 6%"
                                    />
                                </v-btn>
                            </template>
                            <span>Export Data</span>
                        </v-tooltip>
                    </v-col>
                </v-row>
                <v-row class="ml-5" no-gutters>
                    <v-col cols="12">
                        <span class="ml-2 subtitle-2 font-weight-bold"
                            >All Case ({{ show_case.allzone }})</span
                        >
                        <span class="ml-7"
                            >{{ show_case.zone }} ({{
                                show_case.sumzone
                            }})</span
                        >
                    </v-col>

                    <br />
                    <v-row>
                        <v-col
                            v-for="(item, index) in show_case.sumenineer"
                            :key="index"
                            cols="6"
                            sm="4"
                        >
                            <span class="ml-2"
                                >{{ item.engineer_name }} ({{
                                    item.num_cases
                                }})</span
                            >
                        </v-col>
                    </v-row>
                    <br />
                </v-row>
            </v-col>
        </v-row>
        <br />
        <div id="onPC" class="d-none d-sm-block">
            <v-card>
                <v-card-title>
                    <v-text-field
                        v-model="search"
                        append-icon="mdi-magnify"
                        label="Search"
                        single-line
                        hide-details
                    ></v-text-field>
                </v-card-title>
                <v-data-table
                    v-if="data.length > 0"
                    calculate-widths
                    :headers="headers"
                    :items="data"
                    :items-per-page="10"
                    :loading="isLoading"
                    :search="search"
                    loading-text="Loading... Please wait"
                >
                    <template v-slot:[`item.caseid`]="{ item }">
                        <v-chip
                            class="ma-2"
                            :color="status_color[item.status_color]"
                            >{{ item.case_id }} - {{ item.subcase }}
                        </v-chip>
                    </template>
                    <template v-slot:[`item.parts`]="{ item }">
                        <div v-for="(items, index) in item.parts" :key="index">
                            <span>{{ items.part_name }} |</span>
                            <span>{{ items.part_description }} |</span>
                            <span style="color: #d50000"
                                >{{ items.status }} #</span
                            >
                            <v-spacer></v-spacer>
                        </div>
                    </template>
                    <template v-slot:[`item.case_title`]="{ item }">
                        <div>
                            <span>{{ item.case_title }}</span>
                        </div>
                    </template>
                    <template v-slot:[`item.remark`]="{ item }">
                        <div>
                            <span>{{ item.remark }}</span>
                        </div>
                    </template>
                    <template v-slot:[`item.action`]="{ item }">
                        <v-speed-dial
                            direction="left"
                            transition="slide-y-reverse-transition"
                        >
                            <template v-slot:activator>
                                <v-btn
                                    elevation="0"
                                    light
                                    color="grey lighten-2"
                                    fab
                                    x-small
                                >
                                    <v-icon>mdi-dots-vertical</v-icon>
                                </v-btn>
                            </template>
                            <v-tooltip
                                top
                                v-if="
                                    team_name == 'ODM' ||
                                        (team_name == 'ONSITE' &&
                                            (role_name == 'TL' ||
                                                role_name == 'Host' ||
                                                role_name == 'WFH')) ||
                                        role_name == 'Admin' ||
                                        team_name == 'NONHP' ||
                                        team_name == 'INVENTORY'
                                "
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        color="teal accent-2"
                                        fab
                                        small
                                        v-on="on"
                                        @click="
                                            editOnsite(
                                                item.maincase_id,
                                                item.branch_id
                                            )
                                        "
                                    >
                                        <v-icon>mdi-square-edit-outline</v-icon>
                                    </v-btn>
                                </template>
                                <span>Edit Onsite</span>
                            </v-tooltip>
                            <v-tooltip top v-if="team_name == 'ONSITE'">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        color="orange accent-5"
                                        fab
                                        small
                                        v-on="on"
                                        @click="returntozone(item.maincase_id)"
                                    >
                                        <v-icon>mdi-restore-alert</v-icon>
                                    </v-btn>
                                </template>
                                <span>Return to Zone</span>
                            </v-tooltip>
                            <v-tooltip top v-if="team_name == 'ONSITE'">
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        color="green accent-5"
                                        fab
                                        small
                                        v-on="on"
                                        @click="onsitetoday(item.maincase_id)"
                                    >
                                        <v-icon>mdi-alarm-multiple</v-icon>
                                    </v-btn>
                                </template>
                                <span>Onsite Today</span>
                            </v-tooltip>
                            <v-tooltip
                                top
                                v-if="
                                    item.project_name === 'ODM' ||
                                        team_name == 'ODM'
                                "
                            >
                                <template v-slot:activator="{ on }">
                                    <v-btn
                                        color
                                        fab
                                        small
                                        v-on="on"
                                        :to="
                                            '/Project/PrintODM/' +
                                                item.maincase_id +
                                                '/' +
                                                item.subcase_id
                                        "
                                        target="_blank"
                                    >
                                        <v-icon small>mdi-fax</v-icon>
                                    </v-btn>
                                </template>
                                <span>Print</span>
                            </v-tooltip>
                        </v-speed-dial>
                    </template>
                </v-data-table>
            </v-card>
        </div>
        <!-- d-sm-none d-md-flex  -->
        <div
            id="onMobile"
            :class="zoneselect != '' ? 'd-sm-none mar-t-40 mb-4' : 'd-sm-none'"
        >
            <div class="no-pd">
                <v-row>
                    <v-col
                        cols="12"
                        class="text-center"
                        v-if="data && data.length === 0 && engineerselect != ''"
                        >no results found</v-col
                    >
                </v-row>
                <v-progress-linear
                    v-if="data && data.length === 0 && engineerselect === ''"
                    indeterminate
                    color="cyan"
                ></v-progress-linear>

                <v-row class="mar-t-30 ml-1" v-if="data && data.length > 0">
                    <v-col cols="12">
                        <v-chip class="ml-2" color="amber">
                            <b>Total Case : {{ data.length }}</b>
                        </v-chip>
                    </v-col>
                </v-row>
                <v-carousel
                    :continuous="true"
                    :cycle="false"
                    :show-arrows="false"
                    light
                    height="100%"
                    hide-delimiter-background
                    show-arrows-on-hover
                >
                    <!-- delimiter-icon="." -->
                    <v-carousel-item
                        v-for="(row, i) in data"
                        :key="i"
                        height="100%"
                    >
                        <!-- @click="change_case(row.parts,row.maincase_id,row.subcase,row.project_name,row.case_id,row.product_group,row.warranty_type) " -->
                        <v-sheet height="100%" tile color="blue darken-3">
                            <v-row class="ml-1 mr-1">
                                <v-col cols="6" md="4">
                                    <!-- <v-btn color="success" class="mr-1" block>
                                        {{ row.case_id }}
                  </v-btn>-->

                                    <v-speed-dial
                                        direction="right"
                                        transition="slide-y-reverse-transition"
                                    >
                                        <template v-slot:activator>
                                            <v-btn
                                                elevation="0"
                                                :color="
                                                    status_color[
                                                        row.status_color
                                                    ]
                                                "
                                                class="mr-1"
                                                block
                                                >{{
                                                    row.case_id +
                                                        "-" +
                                                        row.subcase
                                                }}</v-btn
                                            >
                                        </template>
                                        <!-- v-if="
                                                team_name != 'Onsite' &&
                                                    role_name != 'Engineer'
                    "-->

                                        <v-tooltip
                                            top
                                            v-if="
                                                team_name == 'ODM' ||
                                                    (team_name == 'ONSITE' &&
                                                        (role_name == 'TL' ||
                                                            role_name ==
                                                                'Host' ||
                                                            role_name ==
                                                                'WFH')) ||
                                                    role_name == 'Admin' ||
                                                    team_name == 'NONHP' ||
                                                    team_name == 'INVENTORY'
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="teal accent-2"
                                                    fab
                                                    small
                                                    v-on="on"
                                                    @click="
                                                        editOnsite(
                                                            row.maincase_id,
                                                            row.branch_id
                                                        )
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-square-edit-outline</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Edit Onsite</span>
                                        </v-tooltip>
                                        <!-- v-if="row.case_id[0] == '5'" -->
                                        <!--  -->
                                        <v-tooltip
                                            top
                                            v-if="team_name == 'ONSITE'"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="orange accent-5"
                                                    fab
                                                    small
                                                    v-on="on"
                                                    @click="
                                                        returntozone(
                                                            row.maincase_id
                                                        )
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-restore-alert</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Return to Zone</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            top
                                            v-if="team_name == 'ONSITE'"
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color="green accent-5"
                                                    fab
                                                    small
                                                    v-on="on"
                                                    @click="
                                                        onsitetoday(
                                                            row.maincase_id
                                                        )
                                                    "
                                                >
                                                    <v-icon
                                                        >mdi-alarm-multiple</v-icon
                                                    >
                                                </v-btn>
                                            </template>
                                            <span>Onsite Today</span>
                                        </v-tooltip>
                                        <v-tooltip
                                            top
                                            v-if="
                                                row.project_name === 'ODM' ||
                                                    team_name == 'ODM'
                                            "
                                        >
                                            <template v-slot:activator="{ on }">
                                                <v-btn
                                                    color
                                                    fab
                                                    small
                                                    v-on="on"
                                                    :to="
                                                        '/Project/PrintODM/' +
                                                            row.maincase_id +
                                                            '/' +
                                                            row.subcase_id
                                                    "
                                                    target="_blank"
                                                >
                                                    <v-icon>mdi-fax</v-icon>
                                                </v-btn>
                                            </template>
                                            <span>Print</span>
                                        </v-tooltip>
                                    </v-speed-dial>
                                </v-col>

                                <v-col cols="6" md="8" class="text-right mt-1">
                                    <v-icon color="amber">mdi-timer</v-icon>
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.created_date }}
                                    </span>
                                </v-col>
                                <v-col cols="12" class="mar-t-10">
                                    <v-icon color="amber"
                                        >mdi-home-circle</v-icon
                                    >
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.site_name }}
                                    </span>
                                </v-col>
                                <v-col cols="12" class="mar-t-10">
                                    <v-icon style="color: #ef6c00"
                                        >mdi-home-map-marker</v-icon
                                    >
                                    <span
                                        class="ml-1"
                                        style="color: #ef6c00; font-weight: bold"
                                    >
                                        {{ row.site_address }}
                                    </span>
                                </v-col>
                                <v-col cols="12" class="mar-t-10">
                                    <v-icon color="amber"
                                        >mdi-car-estate</v-icon
                                    >
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.case_title }}
                                    </span>
                                </v-col>
                                <v-col class="mar-t-10" cols="12">
                                    <v-icon color="amber"
                                        >mdi-account-circle</v-icon
                                    >
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.customer_name }}
                                    </span>
                                </v-col>
                                <v-col class="mar-t-10" cols="12">
                                    <v-icon style="color: #ffff00"
                                        >mdi-whatsapp</v-icon
                                    >
                                    <a
                                        style="color: #ffff00; font-weight: bold"
                                        :href="`tel:${row.customer_tel}`"
                                        class="ml-1"
                                        >{{ row.customer_tel }}</a
                                    >

                                    <!-- {{ row.customer_tel }} -->
                                </v-col>
                                <v-col class="mar-t-10" cols="6">
                                    <v-icon color="amber">mdi-tag</v-icon>
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.product_serial }}
                                    </span>
                                </v-col>
                                <v-col
                                    class="mar-t-10"
                                    cols="6"
                                    v-if="row.product_no"
                                >
                                    <v-icon color="amber"
                                        >mdi-cellphone-link</v-icon
                                    >
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.product_no }}
                                    </span>
                                </v-col>
                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-if="row.customer_email"
                                >
                                    <v-icon color="amber">mdi-gmail</v-icon>
                                    <span class="ml-1 font-onsite-mobile">
                                        {{ row.customer_email }}
                                    </span>
                                </v-col>

                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-if="row.remark"
                                >
                                    <v-icon color="amber"
                                        >mdi-chat-alert</v-icon
                                    >
                                    <span class="ml-1 font-onsite-mobile">{{
                                        row.remark
                                    }}</span>
                                </v-col>

                                <v-col
                                    class="mar-t-10"
                                    cols="12"
                                    v-for="(r, index) in row.parts"
                                    :key="index"
                                >
                                    <v-icon
                                        :style="
                                            r.status == 'Reserve'
                                                ? 'color:#D500F9;'
                                                : 'color:#00e5d2;'
                                        "
                                        >mdi-pound</v-icon
                                    >
                                    <span
                                        :style="
                                            r.status == 'Reserve'
                                                ? 'color:#D500F9; font-weight: bold;'
                                                : 'color:#00e5d2; font-weight: bold;'
                                        "
                                        class="ml-1"
                                        v-if="
                                            r.ponumber && r.ponumber !== 'null'
                                        "
                                        >{{ r.ponumber + " / " }}</span
                                    >
                                    <span
                                        class="ml-1"
                                        :style="
                                            r.status == 'Reserve'
                                                ? 'color:#D500F9; font-weight: bold;'
                                                : 'color:#00e5d2; font-weight: bold;'
                                        "
                                    >
                                        {{
                                            r.part_name +
                                                " - " +
                                                r.part_description
                                        }}
                                    </span>
                                </v-col>
                            </v-row>
                            <v-row v-if="row.lognote && row.lognote.length > 0">
                                <v-col
                                    cols="12"
                                    style="background-color: #e1f4fe"
                                >
                                    <v-textarea
                                        v-model="row.lognote"
                                        background-color="light-blue lighten-5"
                                        color="white"
                                        label="Log Note..."
                                        rows="6"
                                    ></v-textarea>
                                </v-col>
                            </v-row>
                            <br />
                        </v-sheet>
                    </v-carousel-item>
                </v-carousel>
            </div>
        </div>

        <v-dialog v-model="dialog" width="700">
            <v-card>
                <v-card-title
                    class="headline grey lighten-2"
                    primary-title
                ></v-card-title>
                <v-card-text>
                    <v-row>
                        <v-divider></v-divider>
                        <v-col cols="12" sm="6" md="3">
                            <v-select
                                :items="svc"
                                v-model="information.branch_id"
                                item-text="branch_name"
                                item-value="branch_id"
                                label="Zone"
                                dense
                                outlined
                                menu-props="auto"
                                hide-details
                                @change="getEngineer(information.branch_id)"
                            ></v-select>
                        </v-col>
                        <v-col cols="12" sm="6" md="3">
                            <v-select
                                :items="engineer"
                                v-model="information.engineer"
                                item-text="emp_name_en"
                                item-value="emp_id"
                                label="Engineer"
                                dense
                                outlined
                            ></v-select>
                        </v-col>
                        <v-col
                            v-if="information.engineer != 'ZONE'"
                            cols="12"
                            sm="6"
                            md="3"
                        >
                            <v-menu
                                v-model="datemenu"
                                :close-on-content-click="false"
                                transition="scale-transition"
                                offset-y
                                max-width="290px"
                            >
                                <template v-slot:activator="{ on }">
                                    <v-text-field
                                        v-model="computedDateFormatted"
                                        label="Date Onsite"
                                        hint="YYYY-MM-DD format"
                                        readonly
                                        v-on="on"
                                        outlined
                                    ></v-text-field>
                                </template>
                                <v-date-picker
                                    :min="today"
                                    v-model="date"
                                    no-title
                                    @input="datemenu = false"
                                ></v-date-picker>
                            </v-menu>
                        </v-col>
                        <v-col
                            v-if="
                                information.engineer != 'ZONE' && date == today
                            "
                            cols="12"
                            sm="6"
                            md="3"
                        >
                            <v-select
                                :items="schedule"
                                item-text="schedule_range"
                                item-value="schedule_id"
                                v-model="information.timeonsite"
                                label="Schedule Time Onsite"
                                dense
                                outlined
                            ></v-select>
                        </v-col>
                    </v-row>
                </v-card-text>
                <v-divider></v-divider>
                <v-card-actions>
                    <v-btn color="blue darken-1" text @click="dialog = false"
                        >Close</v-btn
                    >
                    <v-spacer></v-spacer>
                    <v-btn color="primary" text @click="saveCase()">Save</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import axios from "axios"
import _ from "lodash"

import { mapState, mapMutations } from "vuex"

export default {
    async mounted() {
        await this.getSchedule()
        await this.getData()
        // await this.getDetail();
    },
    watch: {
        // whenever question changes, this function will run
        datenew: function(newQuestion, oldQuestion) {
            this.showengineer = false
            this.engineerselect = ""
            this.get_zone(this.datenew)
        },
    },
    methods: {
        ...mapMutations(["mutateIsLoading"]),
        async getSchedule() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/schedule-time`
            try {
                const { data } = await axios.get(url)
                this.schedule = data
            } catch (error) {
                console.log(error)
            }
        },
        async getData(editdatenew, editzone) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            const url = `${process.env.VUE_APP_ROOT_API}/api/get-scheduled-date`
            try {
                const { data } = await axios.get(`${url}`, options)

                this.arrayEvents = [
                    ...data.scheduled.map((each) => {
                        return each.onsite_at
                    }),
                ]
                // console.log(editzone)
                if (editzone !== undefined) {
                    this.datenew = editdatenew
                    this.get_zone(editzone)
                } else if (data.scheduled.length > 0) {
                    this.datenew = this.arrayEvents[0]
                    this.get_zone(this.arrayEvents[0])
                }
                // console.log(this.arrayEvents)
                // console.log(this.datenew)
            } catch (error) {
                console.log(error, "-error")
            }
        },
        getDetail: _.debounce(async function() {
            // console.log("-getDetail")
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }

            const url = `${process.env.VUE_APP_ROOT_API}/api/view-assigned/${this.datenew}/${this.zoneselect}`

            try {
                if (this.datenew != "") {
                    this.mutateIsLoading()
                    this.data = []
                    const { data } = await axios.get(`${url}`, options)

                    if (this.zone !== null) {
                        this.zone.map((each) => {
                            if (this.zoneselect == each.branch_id) {
                                this.show_case.zone = each.branch_name
                            }
                        })
                    }
                    this.show_case.allzone = data.sum
                    this.show_case.sumzone = data.sum_zone

                    this.engineer = data.data
                    let text = []
                    data.data.map((each) => {
                        text.push({
                            engineer_name: each.emp_name_en,
                            num_cases: each.num_cases,
                        })
                        each.cases.map((res) => {
                            this.data.push({
                                engineername: each.emp_name_en,
                                ...res,
                            })
                        })
                    })
                    this.show_case.sumenineer = [...text]
                    this.mutateIsLoading()
                    if (
                        localStorage.team_name === "ODM" &&
                        localStorage.role_name === "Engineer"
                    ) {
                        await this.get_emp()
                        await this.chooseEngineer()
                    }
                    this.showengineer = true
                }
            } catch (error) {
                console.log(error)
            }
        }, 1000),
        chooseEngineer() {
            this.data = []
            if (this.engineerselect === undefined) {
                this.engineer.map((each) => {
                    each.cases.map((res) => {
                        this.data.push({
                            engineername: each.emp_name_en,
                            ...res,
                        })
                    })
                })
            } else {
                this.engineer.map((each) => {
                    if (each.emp_id == this.engineerselect) {
                        each.cases.map((res) => {
                            this.data.push({
                                engineername: each.emp_name_en,
                                ...res,
                            })
                        })
                    }
                })
            }
        },
        returntozone(params) {
            this.$swal({
                title: "Are you sure ?",
                text: "return case to zone",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then(async (confirm) => {
                if (confirm) {
                    this.data.map((each) => {
                        if (each.maincase_id == params) {
                            this.information = {
                                subcase_id: each.subcase_id,
                                maincase_id: each.maincase_id,
                                branch_id: "",
                                engineer: "ZONE",
                                dateonsite: "",
                                timeonsite: "",
                            }
                        }
                    })
                    const url = `${process.env.VUE_APP_ROOT_API}/api/save-assigned`
                    const options = {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                    const { data } = await axios.post(
                        `${url}`,
                        this.information,
                        options
                    )
                    if (data != "update - complete") {
                        swal({
                            title: "update error",
                            icon: "error",
                            button: "OK",
                        })
                    } else {
                        this.getData(this.datenew, this.zoneselect)
                        this.getDetail()
                    }
                }
            })
        },
        onsitetoday(params) {
            this.$swal({
                title: "Are you sure ?",
                text: "change case to onsite today",
                icon: "warning",
                buttons: true,
                primaryMode: true,
            }).then(async (confirm) => {
                if (confirm) {
                    this.data.map((each) => {
                        if (each.maincase_id == params) {
                            this.information = {
                                subcase_id: each.subcase_id,
                                maincase_id: each.maincase_id,
                                branch_id: "",
                                engineer: "",
                                dateonsite: "today",
                                timeonsite: "",
                            }
                        }
                    })
                    const url = `${process.env.VUE_APP_ROOT_API}/api/save-assigned`
                    const options = {
                        headers: {
                            Authorization: "Bearer " + localStorage.token,
                        },
                    }
                    const { data } = await axios.post(
                        `${url}`,
                        this.information,
                        options
                    )
                    if (data != "update - complete") {
                        swal({
                            title: "update error",
                            icon: "error",
                            button: "OK",
                        })
                    } else {
                        this.getData(this.datenew, this.zoneselect)
                        this.getDetail()
                    }
                }
            })
        },
        async editOnsite(params, branch_id) {
            let site_province_id
            let site_amphur_id

            this.data.map((each) => {
                if (each.maincase_id == params) {
                    site_province_id = each.site_province_id
                    site_amphur_id = each.site_district_id
                    this.information.subcase_id = each.subcase_id
                    this.information.maincase_id = each.maincase_id
                    this.information.engineer = each.engineer
                }
            })
            const [day, month, year] = this.data[0].onsite_date.split("/")
            this.date = `${year}-${month}-${day}`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }
            // const url = `${process.env.VUE_APP_ROOT_API}/api/svc-zone-ce/${site_province_id}/${site_amphur_id}`
            const url = `${process.env.VUE_APP_ROOT_API}/api/get-zone-ce/${site_province_id}`
            try {
                const { data } = await axios.get(`${url}`, options)
                this.svc = data
                this.getEngineer(branch_id)
            } catch (error) {
                console.log(error)
            }
            this.dialog = true
        },
        getEngineer(branch_id) {
            this.information.branch_id = branch_id
            this.svc.map((each) => {
                if (each.branch_id == this.information.branch_id) {
                    this.engineer = ["ZONE", ...each.engineer]
                }
            })
        },

        formatDate(date) {
            if (!date) return null
            const [year, month, day] = date.split("-")
            return `${year}-${month}-${day}`
        },
        async saveCase() {
            const url = `${process.env.VUE_APP_ROOT_API}/api/save-assigned`
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                },
            }
            this.mutateIsLoading()
            const { data } = await axios.post(
                `${url}`,
                this.information,
                options
            )
            if (data != "update - complete") {
                swal({
                    title: "Upload error",
                    icon: "error",
                    button: "OK",
                })
            }

            this.getData(this.datenew, this.zoneselect)
            this.mutateIsLoading()
            this.getDetail()
            this.dialog = false
        },
        allowedDates(val) {
            if (this.arrayEvents && this.arrayEvents.includes(val)) {
                // if (this.arrayEvents.includes(val)) {
                return val
            }
        },
        async get_zone(onsite_at) {
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }
            let url =
                `${process.env.VUE_APP_ROOT_API}/api/get-zone/` + onsite_at
            await axios.get(url, options).then((response) => {
                this.zone = response.data.zone
                if (this.zone !== null) {
                    this.zoneselect = this.zone[0].branch_id
                    this.information.branch_id = this.zone[0].branch_id
                }
            })
            this.getDetail()
        },
        async get_emp() {
            this.mutateIsLoading()
            const options = {
                headers: {
                    Authorization: "Bearer " + localStorage.token,
                    "Content-Type": "multipart/form-data",
                },
            }
            await axios
                .get(
                    `${process.env.VUE_APP_ROOT_API}/api/account-detail`,
                    options
                )
                .then((response) => {
                    this.engineerselect = response.data.emp_id
                    this.mutateIsLoading()
                })
        },
        async export_data() {
            // this.mutateIsLoading();
            this.chk_export_data = true
            await axios({
                url: `${process.env.VUE_APP_ROOT_API}/api/export-assigned`,
                method: "POST",
                responseType: "blob",
                data: { onsite_at: this.datenew, branch_id: this.zoneselect },
                headers: { Authorization: "Bearer " + localStorage.token },
            }).then((response) => {
                this.chk_export_data = false
                let fileURL = window.URL.createObjectURL(
                    new Blob([response.data])
                )
                let fileLink = document.createElement("a")

                fileLink.href = fileURL
                fileLink.setAttribute("download", "report.xlsx")
                document.body.appendChild(fileLink)

                fileLink.click()
                // this.mutateIsLoading();
            })
        },
    },
    computed: {
        ...mapState(["isLoading"]),
        computedDateFormatted() {
            this.information.dateonsite = this.formatDate(this.date)
            return this.information.dateonsite
        },
    },
    data() {
        return {
            chk_export_data: false,
            status_color: ["indigo lighten-3", "success", "amber"],
            no: 1,
            team_name: localStorage.team_name,
            role_name: localStorage.role_name,
            datenew: "",
            date: new Date().toISOString().substr(0, 10),
            dialog: false,
            pickerDate: null,
            arrayEvents: null,
            zoneselect: "",
            engineerselect: "",
            showengineer: false,
            zone: [],
            information: {
                maincase_id: "",
                subcase_id: "",
                branch_id: "",
                engineer: "",
                dateonsite: "",
                timeonsite: "",
            },
            datemenu: false,
            engineer: [],
            data: [],
            svc: [],
            schedule: [],
            search: null,
            today: new Date().toISOString().substr(0, 10),
            headers: [
                // {
                //     text: "#",
                //     value: "no",
                //     class: "text-uppercase darken-3 black--text body-2",
                // },
                {
                    text: "CASE ID",
                    value: "case_id",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "SERIAL",
                    value: "product_serial",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "CASE TITLE",
                    value: "case_title",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "SITE NAME",
                    value: "site_name",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "ADDRESS",
                    value: "site_address",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "Part",
                    value: "parts",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "ZONE CE",
                    value: "engineername",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "REMARK",
                    value: "remark",
                    class: "text-uppercase darken-3 black--text body-2",
                },
                {
                    text: "Action",
                    value: "action",
                    class: "text-uppercase darken-3 black--text body-2",
                },
            ],
            show_case: {
                allzone: "",
                zone: "",
                sumzone: "",
                sumenineer: [],
            },
            search: "",
        }
    },
}
</script>
<style>
.font-onsite-mobile {
    color: rgb(247, 251, 255) !important;
}
</style>
